import {ChipProps} from "@mui/material/esm";
import {ColorChip} from "../color-chip/ColorChip";
import {amber} from "@mui/material/colors";
import StarIcon from "@mui/icons-material/Star";
import React from "react";
import {Stack, Tooltip, Typography} from "@mui/material";

const scoreDescription = {
    global: 'How strong the match is across the whole company. We look for your closest teammates (people under the same manager) who sit in this neighbourhood. Your manager being here counts extra, and each additional teammate adds a bit less than the previous one. The raw “team closeness” is then scaled by the size of that team in the whole company. Higher is better.',
    local: 'How strong the match is inside this office. It is calculated the same way as the global score (manager counts extra; each teammate adds slightly less) but scaled by the size of the team in this office only. Higher is better.',
}

function ScoreTooltip({type}: {
    type: 'global' | 'local'
}) {
    return (
        <Stack>
            <Typography variant="h6">{type === 'global' ? 'Global Score' : 'Local Score'}</Typography>
            <Typography variant="body1">
                {scoreDescription[type]}
            </Typography>
        </Stack>
    );
}


export function NeighbourhoodMatchScoreChip({score, type, size}: {
    score: number,
    type: 'global' | 'local',
    size?: ChipProps['size'],
}) {
    return (
        <Tooltip title={<ScoreTooltip type={type}/>}>
            <ColorChip
                label={`${type === 'global' ? 'G' : 'L'}-${score}`}
                size={size}
                color={score > 100 ? amber["100"] : undefined}
                icon={<StarIcon color={score > 100 ? 'warning' : undefined}/>}
            />
        </Tooltip>
    );
}